import React, {useEffect, useState} from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@material-ui/core';
import {createUniqueId} from '../../helpers/createUniqueId';
import {Place} from '../../models';
import PlaceEdit from './PlaceEdit';


interface Props {
  onClose?: (value: string) => void,
  open?: boolean,
  place?: Place | null,
}


const PlaceEditDialog = ({open=false, ...props}: Props) => {

  const {place, onClose} = props;

  const [formId, setFormId] = useState<string>("placeForm");
  useEffect(() => {
    setFormId(createUniqueId());
  }, []);

  const [error, setError] = useState<string|null>(null);
  const handleError = (message: string) => {
    setError(message);
  };

  const handleClose = () => {
    onClose && onClose('Closed');
  };

  return (
    <div>
      <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="place-edit-dialog-title"
      >
        <DialogTitle id="place-edit-dialog-title">
          Edit Place
        </DialogTitle>
        <DialogContent>
          <PlaceEdit
            place={place}
            formId={formId}
            onComplete={handleClose}
            onError={handleError}
            hideButtons
            hideError
          />
        </DialogContent>
        <DialogActions>
          {error &&
            <Typography variant="body1" color="error">
              {error}
            </Typography>
          }
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button
              color="primary"
              type="submit"
              form={formId}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default PlaceEditDialog;
